import { ClientLogoResponse } from '../../api-models';
import { HTTPMethod } from '../../types/enums';
import { AdapterInterface } from '../../types/global';
import BaseAdapter from './baseAdapter';

export default class PostClientLogo extends BaseAdapter<ClientLogoResponse> implements AdapterInterface {
  rawResponse: ClientLogoResponse;

  async adaptResponse(): Promise<string> {
    await this.fetchApiResponse('/api/client-logo', HTTPMethod.Get);
    return this.rawResponse.signed_url;
  }
}
